import React from 'react';

import { ReviewDetails } from '../ProductDetailsPage';

interface ReviewItemProps {
  item: ReviewDetails;
  domainPrefix: string;
  productsId: number;
}

export default class ReviewItem extends React.Component<ReviewItemProps> {
  render() {
    return (
      <div className="review">
        <div className="productReviewsDefaultReviewer bold">
          {this.formatDate(this.props.item.date_added)} von{' '}
          {this.props.item.customers_name}
        </div>
        <div className="rating">
          <img
            src={
              'includes/templates/template_default/images/stars_' +
              this.props.item.reviews_rating +
              '.png'
            }
            alt={this.props.item.reviews_rating + ' von 5 Sternen'}
            title={' ' + this.props.item.reviews_rating + ' von 5 Sternen '}
            width="55"
            height="11"
          />{' '}
          {this.props.item.reviews_rating}
          {' von 5 Sternen'}
        </div>
        <div className="productReviewsDefaultProductMainContent content">
          {this.props.item.reviews_text}
        </div>
      </div>
    );
  }
  formatDate(input: any) {
    let date = new Date(input);
    let day: any = date.getDate();
    let month: any = date.getMonth();
    month = month + 1;
    if (String(day).length == 1) day = '0' + day;
    if (String(month).length == 1) month = '0' + month;

    let dateT = day + '.' + month + '.' + date.getFullYear();
    return dateT;
  }
}
